/**
 * テナントが扱える排出事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/emissions`

const search_emission = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/locations`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_emission
